import React, { ReactNode } from "react";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import { DriveFolderUpload, FileUpload } from "@mui/icons-material";
import { CustomButton } from "../../CustomButton";

interface ISingleFileUploadIconProps {
    type?: "ICON" | "BUTTON" | "BUTTON_WITH_ICON"
    title?: string
    icon?: ReactNode
    disabled?: boolean
    accept?: string
    onChange: (file: File) => void
}
export const SingleFileUploadButton: React.FC<ISingleFileUploadIconProps> = ({ title, disabled, accept, type, icon, onChange }) => {
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) onChange(file)
        event.target.value = "";
    };


    const isLightMode = useTheme().palette.mode === "light";
    return (
        <>
            <input
                type="file"
                ref={fileInputRef}
                hidden
                accept={accept}
                onChange={handleFileChange}
            />
            {type === "BUTTON" ? (
                <CustomButton
                    variant="outlined"
                    color="primary"
                    sx={{
                        minWidth: "80px !important",
                        backgroundColor: isLightMode
                            ? "var(--secondary-color)"
                            : "var(--primary-color)",
                        color: isLightMode
                            ? "var(--text-light-color)"
                            : "var(--text-dark-color)",
                        border: isLightMode
                            ? "var(--border-light-color) 1px solid"
                            : "var(--border-dark-color) 1px solid",
                        "&:hover": {
                            backgroundColor: isLightMode
                                ? "var(--secondary-color)"
                                : "var(--tertiary-color)",
                            opacity: isLightMode ? 0.85 : 1,
                            // color: isLightMode ? "var(--primary-color)" : "var(--secondary-color)",
                            border: isLightMode
                                ? "var(--border-light-color) 1px solid"
                                : "var(--border-dark-color) 1px solid",
                        },
                    }}
                    onClick={handleClick}
                >
                     {icon || <FileUpload sx={{ fontSize: 22 }} />}{title || "Upload File"}
                </CustomButton>
            ) : (
                <Tooltip title={title || "Upload File"}>
                    <IconButton disabled={disabled} onClick={handleClick}>
                        {icon || <DriveFolderUpload sx={{ fontSize: 22 }} />}
                    </IconButton>
                </Tooltip>
            )

            }

        </>
    );
}
